/**
 * Property width can be customized with UIWidth metadata (admin app) and set to flex-basis value.
 * The following values supported:
 * - numbers from 0 to 100
 * - 'auto'
 * - default value is 100
 */
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PropertyGroupType } from '../../../core/models/property-group-type.model';
import { Entity } from '../../../core/models/entity.model';
import { PropertyType } from '../../../core/models/property-type.model';
import { UntypedFormGroup } from '@angular/forms';
import type { EntityEditorPropertyChangedEvent } from '../../models/entity-editor-property-changed.event';
import { EntityPropertyEditorComponent } from '../../components/entity-property-editor/entity-property-editor.component';
import type { ComponentType } from '@angular/cdk/overlay';
import type { PropertyEditorInputs } from '../property-editor-inputs';

@Component({
  selector: 'app-entity-group',
  templateUrl: './entity-group.component.html',
  styleUrls: ['./entity-group.component.scss'],
  standalone: false
})
export class EntityGroupComponent {
  @Input() groupType: PropertyGroupType;
  @Input() entity: Entity;
  @Input() entityForm: UntypedFormGroup;

  @Input() propertyEditorComponent: ComponentType<PropertyEditorInputs> = EntityPropertyEditorComponent;

  @Output() propertyChange = new EventEmitter<EntityEditorPropertyChangedEvent>();

  protected propertyChanged(event: EntityEditorPropertyChangedEvent): void {
    this.propertyChange.emit(event);
  }

  getUIWidth(propertyType: PropertyType) {
    const uiWidthMetadata = propertyType.MetaData['UIWidth'];
    if (uiWidthMetadata !== undefined) {
      if (uiWidthMetadata !== 'auto') {
        return `${uiWidthMetadata}%`;
      }
      return uiWidthMetadata;
    }
    return '100%';
  }

  isButton(propertyType: PropertyType) {
    const uiPresentation = propertyType.MetaData['UIPresentation'];
    if (uiPresentation !== undefined) {
      if (uiPresentation === 'Button' || uiPresentation === 'BooleanButton') {
        return true;
      }
    }
    return false;
  }
}
